module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    class: {
      'login_footer': _vm.stateName == 'login' || _vm.stateName == 'resetpassword' || _vm.stateName == 'signup'
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('version', {
    staticStyle: {
      "padding-right": "40px",
      "cursor": "pointer",
      "display": "inline"
    },
    attrs: {
      "justword": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "40px",
      "cursor": "pointer"
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "40px",
      "cursor": "pointer"
    }
  }, [_vm._v("Contact")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36cf1e47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 799
// module chunks = 1